import React, { useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import UnderDevelopmentPage from '../../UnderDevelopmentPage'
import { Grid } from '@mui/material'
import MaterialBox from '../../../components/MaterialBox'
import MaterialTypography from '../../../components/MaterialTypography'
import './BugList.css'

const BugList = () => {
  const [data, setData] = useState([
    { id: 1, bugName: "Login Error", project: "AppX", module: "Auth", priority: "High", owner: "Alice", assigned: "Bob", action: "Pending" },
    { id: 2, bugName: "UI Misalignment", project: "WebPortal", module: "Dashboard", priority: "Medium", owner: "John", assigned: "Sara", action: "Pending" },
    { id: 3, bugName: "Crash on Save", project: "CRM", module: "Contacts", priority: "Critical", owner: "Eve", assigned: "Tom", action: "Pending" },
    { id: 4, bugName: "Slow Loading", project: "Analytics", module: "Reports", priority: "Low", owner: "Mike", assigned: "Nina", action: "Pending" },
    { id: 5, bugName: "Broken Link", project: "Website", module: "Footer", priority: "Low", owner: "Sam", assigned: "Rob", action: "Pending" },
    { id: 6, bugName: "Data Sync Issue", project: "MobileApp", module: "Sync", priority: "High", owner: "Lara", assigned: "Zack", action: "Pending" },
    { id: 7, bugName: "Duplicate Entry", project: "ERP", module: "Inventory", priority: "Medium", owner: "Rick", assigned: "Mia", action: "Pending" },
    { id: 8, bugName: "Email Not Sent", project: "MailSystem", module: "Notifications", priority: "High", owner: "Harry", assigned: "June", action: "Pending" },
  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15;

  const handleActionChange = (id, value) => {
    const updated = data.map((row) =>
      row.id === id ? { ...row, action: value } : row
    );
    setData(updated);
  };

  
  const filteredData = data.filter((row) =>
    Object.values(row).some((val) =>
      val.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

 
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentRows = filteredData.slice(startIndex, startIndex + rowsPerPage);

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  
  return (
    <DashboardLayout>
      <Grid container direction='column' gap={2} p={1}>
        <Grid size={{ xs: 12, sm: 12 }}>
          <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            <MaterialTypography variant='h4' color='dark' sx={{ fontWeight: 'bold' }}>Bugs List</MaterialTypography>
            <MaterialTypography variant='caption' color='secondary'>List of bugs you can view here.</MaterialTypography>
          </MaterialBox>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <div className="table-container">

            <input
              type="text"
              className="search-input"
              placeholder="Search bugs..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />

            <table className="custom-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Bug Name</th>
                  <th>Project</th>
                  <th>Module</th>
                  <th>Priority</th>
                  <th>Owner</th>
                  <th>Assigned</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentRows.length > 0 ? (
                  currentRows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.bugName}</td>
                      <td>{row.project}</td>
                      <td>{row.module}</td>
                      <td>{row.priority}</td>
                      <td>{row.owner}</td>
                      <td>{row.assigned}</td>
                      <td>
                        <select
                          className={`action-select ${row.action.toLowerCase()}`}
                          value={row.action}
                          onChange={(e) => handleActionChange(row.id, e.target.value)}
                        >
                          <option value="Pending">Pending</option>
                          <option value="Fixed">Fixed</option>
                        </select>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center", color: "#888" }}>
                      No results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="pagination">
              <button onClick={handlePrev} disabled={currentPage === 1}>
                Previous
              </button>

              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i + 1}
                  className={currentPage === i + 1 ? "active" : ""}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}

              <button onClick={handleNext} disabled={currentPage === totalPages}>
                Next
              </button>
            </div>
          </div>
        </Grid>
      </Grid>
      {/* <UnderDevelopmentPage /> */}
    </DashboardLayout>
  )
}

export default BugList
